import { useQuery } from "@tanstack/react-query";
import { gqlRequest } from "@/api/graphql/request";
import { DASHBOARD_DOMAIN_USAGE } from "@/api/graphql/operations/dashboard";

interface DomainUsageItem {
  domain: string;
  count: number;
}

export function useDomainUsage() {
  return useQuery({
    queryKey: ["dashboard", "domain-usage"],
    queryFn: () =>
      gqlRequest<{ dashboardDomainUsage: DomainUsageItem[] }>(
        DASHBOARD_DOMAIN_USAGE,
      ).then((d) => d.dashboardDomainUsage),
    staleTime: 60_000,
  });
}
